import { useCallback } from 'react';

const useInsights = (summaryData, channelData) => {
  const generateActionableInsights = useCallback(() => {
    if (!summaryData || Object.keys(summaryData).length === 0) return [];

    const insights = [];
    const currentDate = new Date();
    
    // ROI Analizi
    const currentROI = summaryData.ROI?.current || 0;
    const targetROI = 8.5;
    if (currentROI < targetROI * 0.9) {
      insights.push({
        type: 'warning',
        category: 'ROI',
        title: 'ROI Hedefin Altında',
        description: `Mevcut ROI (${currentROI.toFixed(2)}) hedefin %${((targetROI - currentROI) / targetROI * 100).toFixed(1)} altında`,
        action: 'Harcama optimizasyonu yapın veya dönüşüm oranlarını artırın',
        priority: 'high',
        icon: '📉'
      });
    } else if (currentROI > targetROI * 1.1) {
      insights.push({
        type: 'success',
        category: 'ROI',
        title: 'ROI Hedefin Üstünde',
        description: `Mükemmel! ROI hedefinizi %${((currentROI - targetROI) / targetROI * 100).toFixed(1)} aştı`,
        action: 'Başarılı kanalların bütçesini artırmayı düşünün',
        priority: 'medium',
        icon: '🎯'
      });
    }

    // Revenue Trend Analizi
    const revenueChange = summaryData.REVENUE?.change || 0;
    if (revenueChange < -10) {
      insights.push({
        type: 'error',
        category: 'Revenue',
        title: 'Ciddi Revenue Düşüşü',
        description: `Revenue %${Math.abs(revenueChange).toFixed(1)} düştü`,
        action: 'Acil eylem gerekli: Pazarlama kampanyalarını gözden geçirin',
        priority: 'critical',
        icon: '🚨'
      });
    } else if (revenueChange < -5) {
      insights.push({
        type: 'warning',
        category: 'Revenue',
        title: 'Revenue Düşüş Trendi',
        description: `Revenue %${Math.abs(revenueChange).toFixed(1)} düştü`,
        action: 'Trend analizi yapın ve müdahale planı hazırlayın',
        priority: 'high',
        icon: '📉'
      });
    }

    // Cost Optimizasyonu
    const totalCost = summaryData['COST(ALL)']?.current || 0;
    const revenue = summaryData.REVENUE?.current || 0;
    const costRatio = revenue > 0 ? (totalCost / revenue) * 100 : 0;
    
    if (costRatio > 15) {
      insights.push({
        type: 'warning',
        category: 'Cost',
        title: 'Yüksek Maliyet Oranı',
        description: `Harcama/ciro oranı %${costRatio.toFixed(1)} (ideal: %12-15 arası)`,
        action: 'Düşük performanslı kampanyaları durdurun, ROI\'i yüksek olanlara odaklanın',
        priority: 'medium',
        icon: '💸'
      });
    }

    // Kanal Performansı
    if (channelData && channelData.length > 0) {
      const totalChannelSpend = channelData.reduce((sum, channel) => sum + channel.value, 0);
      const metaSpend = channelData.find(c => c.name === 'Meta CR')?.value || 0;
      const metaRatio = totalChannelSpend > 0 ? (metaSpend / totalChannelSpend) * 100 : 0;
      
      if (metaRatio > 70) {
        insights.push({
          type: 'info',
          category: 'Channel',
          title: 'Meta Ağırlıklı Harcama',
          description: `Harcamanızın %${metaRatio.toFixed(1)}'i Meta'da`,
          action: 'Risk dağıtmak için Google Ads ve diğer kanalları test edin',
          priority: 'low',
          icon: '⚖️'
        });
      }
    }

    // Hafta içi/hafta sonu analizi
    const weekday = currentDate.getDay();
    if (weekday === 1) { // Pazartesi
      insights.push({
        type: 'info',
        category: 'Timing',
        title: 'Hafta Başı Momentum',
        description: 'Yeni hafta başladı - performansı yakından takip edin',
        action: 'Haftalık hedefleri gözden geçirin ve kampanya optimizasyonlarını uygulayın',
        priority: 'low',
        icon: '🚀'
      });
    }

    // Tarih bazlı öneriler
    const dayOfMonth = currentDate.getDate();
    if (dayOfMonth <= 5) {
      insights.push({
        type: 'info',
        category: 'Monthly',
        title: 'Ay Başı Fırsatı',
        description: 'Ay başında kullanıcılar daha aktif olabilir',
        action: 'Yeni kampanya lansmanları için ideal zaman',
        priority: 'low',
        icon: '📅'
      });
    }

    return insights.sort((a, b) => {
      const priorityOrder = { critical: 4, high: 3, medium: 2, low: 1 };
      return priorityOrder[b.priority] - priorityOrder[a.priority];
    });
  }, [summaryData, channelData]);

  return { generateActionableInsights };
};

export default useInsights;